import React from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import {useTheme} from '@rn-vui/themed';

import PressableWithOpacityFeedback from '../../ui-controls/PressableWithOpacityFeedback';

type RewardsCardVariant = 'subtle' | 'warning';
type RewardsCardPadding = 's2' | 's3' | 's4';

type RewardsCardProps = {
  variant?: RewardsCardVariant;
  padding?: RewardsCardPadding;
  onPress?: () => void;
  children: React.ReactNode;
  testID?: string;
  accessibilityLabel?: string;
  style?: StyleProp<ViewStyle>;
};

function RewardsCard({
  variant = 'subtle',
  padding = 's3',
  onPress,
  children,
  testID,
  accessibilityLabel,
  style,
}: RewardsCardProps) {
  const {theme} = useTheme();

  const backgroundColor =
    variant === 'warning' ? theme.colors.surfaceWarning : theme.colors.surfaceSubtle;

  const containerStyle: ViewStyle = {
    backgroundColor,
    borderRadius: theme.size?.s2 ?? 8,
    padding: theme.size?.[padding] ?? 12,
    ...(variant === 'subtle' ? {borderWidth: 1, borderColor: theme.colors.borderSubtle} : {}),
  };

  if (onPress) {
    return (
      <PressableWithOpacityFeedback
        onPress={onPress}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        testID={testID}
        style={[containerStyle, style]}>
        {children}
      </PressableWithOpacityFeedback>
    );
  }

  return (
    <View testID={testID} accessibilityLabel={accessibilityLabel} style={[containerStyle, style]}>
      {children}
    </View>
  );
}

export default RewardsCard;
